import React from "react";
import "./Trailer.css";
import SafeArea from "../../basic/safe-area";
import Networks from "../../basic/social-networks-row/Networks";
import hamlet from "../../../assets/images/videos/hamlet.mp4";
import hamlet_teaser from "../../../assets/images/videos/hamlet_teaser.mp4";
import { useI18n } from "../../../i18n/i18n";

const Trailer: React.FC<{ scrollTargetId: string }> = ({ scrollTargetId }) => {
    const { t } = useI18n();
    const [showTrailer, setShowTrailer] = React.useState(false);

    const openTrailer = () => {
        setShowTrailer(true);
        document.body.style.overflow = "hidden"; // disable scroll
    };

    const closeTrailer = () => {
        setShowTrailer(false);
        document.body.style.overflow = ""; // restore scroll
    };

    React.useEffect(() => {
        const handleEsc = (e: KeyboardEvent) => {
            if (e.key === "Escape") closeTrailer();
        };
        window.addEventListener("keydown", handleEsc);
        return () => window.removeEventListener("keydown", handleEsc);
    }, []);

    return (
        <>
            <div className="movie-photo">
                <video className="movie-video" src={hamlet_teaser} autoPlay loop muted playsInline />

                <div className="fs64 fw700 movie-title" onClick={openTrailer}>
                    <SafeArea>
                        <div className="d-flex aic pointer">
                            <div className="movie-trailer-bullet-point" />
                            <div>{t("nav.watchTrailer")}</div>
                        </div>
                    </SafeArea>
                </div>

                <div className="movie-photo-redes w100">
                    <SafeArea>
                        <Networks extended scrollTargetId={scrollTargetId} />
                    </SafeArea>
                </div>
            </div>

            {showTrailer && (
                <div className="trailer-overlay" onClick={closeTrailer}>
                    <div
                        className="trailer-content"
                        onClick={(e) => e.stopPropagation()} // prevent closing when clicking video
                    >
                        <button className="trailer-close" onClick={closeTrailer}>
                            {t("common.close")}
                        </button>

                        <iframe
                            src="https://www.youtube.com/embed/hBJm2-jnDJw?autoplay=1&start=2&mute=1"
                            title="Trailer"
                            className="trailer-video"
                            style={{ border: "none" }}
                            allow="autoplay; encrypted-media; picture-in-picture"
                            allowFullScreen
                        />
                    </div>
                </div>
            )}
        </>
    );
};

export default Trailer;
